import { Component, ChangeDetectionStrategy, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";
import "@maersk-global/mds-components-core-icon";
import "@maersk-global/mds-components-core-side-bar";
import "@maersk-global/mds-components-core-top-bar";
import { AvatarDropdown } from "../../shared/components/avatar-dropdown/avatar-dropdown";

@Component({
  selector: "app-layout",
  imports: [RouterLink, RouterLinkActive, RouterOutlet, AvatarDropdown],
  templateUrl: "./app-layout.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppLayoutComponent {}
